import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter 517 (Kamel) — « me mettre la pression, gentiment » : bandeau tâches en retard / aujourd'hui / semaine.
export default function TachesBanner({ getAuthConfig, onOpen, active }) {
  const [r, setR] = useState(null);
  useEffect(() => {
    let stop = false;
    axios.get(`${API}/admin/taches/resume`, getAuthConfig()).then(res => { if (!stop) setR(res.data); }).catch(() => {});
    return () => { stop = true; };
  }, [getAuthConfig, active]);
  if (!r || (r.retard === 0 && r.aujourdhui === 0 && r.semaine === 0)) return null;
  const rouge = r.retard > 0;
  return (
    <button type="button" onClick={onOpen}
      className={`w-full text-left px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-bold flex items-center gap-2 sm:gap-3 whitespace-nowrap overflow-hidden ${rouge ? 'bg-red-600 text-white' : 'bg-amber-400 text-amber-950'}`}
      data-testid="taches-banner">
      <span>{rouge ? '⏰' : '✅'} Tâches :</span>
      {r.retard > 0 && <span data-testid="taches-banner-retard">{r.retard} en retard</span>}
      {r.aujourdhui > 0 && <span>· {r.aujourdhui} aujourd'hui</span>}
      {r.semaine > 0 && <span className="hidden sm:inline">· {r.semaine} cette semaine</span>}
      {rouge && r.liste_retard?.[0] && <span className="font-normal opacity-90 truncate hidden md:inline">— « {r.liste_retard[0].titre} »{r.retard > 1 ? '…' : ''}</span>}
      <span className="ml-auto text-xs underline">ouvrir →</span>
    </button>
  );
}
